<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="7" :sm="8">
            <a-form-item
              :label="$t(I18N_KEY.REPAYREPORT + 'requestDate')"
            >
              <a-range-picker v-model="queryParam.examineDate" format="YYYY-MM-DD" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="'产品类型'">
              <a-select mode='multiple'
                        v-model='queryParam.appSsids'
              >
                <a-select-option v-for='item in appList' :key='item.appssid'>
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="'主产品'">
              <a-select mode='multiple'
                        v-model='queryParam.mainSids'
              >

                <a-select-option v-for='item in mainAppList' :key='item.appssid'>
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="7" :sm="24">
            <a-form-item label="币种" style="margin-bottom: 0;">
              <a-radio-group v-model="currencyCode" @change="onCurrencyChange" button-style="solid">
                <a-radio-button value="LOCAL">本币</a-radio-button>
                <a-radio-button value="CNY">人民币 ({{ cnyRate }})</a-radio-button>
                <a-radio-button value="USD">美金 ({{ usdRate }})</a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery('')" icon="search" style="margin-left: 8px">{{
                  $t('search')
                }}</a-button>
              <a-button type="primary" @click="searchQuery('1')" icon="search" style="margin-left: 8px">首贷</a-button>
              <a-button type="primary" @click="searchQuery('2')" icon="search" style="margin-left: 8px">复贷</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{
                  $t('reset')
                }}</a-button>
              <!--<a-button type="primary" @click="downLoadData" icon="download" style="margin-left: 8px">{{ $t('exportFile') }}</a-button>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        bordered
        @change="handleTableChange"
      >
        <Dict slot="approvalStatus" slot-scope="text" :dict-code="DICT_CODE.ORDER_STATUS">{{ text }}</Dict>
      </a-table>
    </div>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getApplist, getApplistExcludingSubApp, getRepaymentReportForAmountReal } from '@/webpublicapi/order'
import exportFile from '@/webpublicapi/exportFile'
import {getExchangeRate} from "@/webpublicapi/statistics";
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import moment from 'moment'
const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  APPROVAL: 'approval.',
  REPAYREPORT: 'repayReport.'
}
export default {
  name: 'repayReport',
  components: {
    Dict,
    DictSelect
  },
  data() {
    return {
      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      exportParams: '',
      // 分页参数
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      appList: [],
      mainAppList: [],
      // 查询条件
      queryParam: {
        examinerName: '',
        mainSids: [],
        appSsids: [],
        duration: '',
        examineDate: undefined
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      },
      currencyCode: 'LOCAL', // 当前货币代码：LOCAL-本币，CNY-人民币，USD-美金
      exchangeRate: 1, // 当前使用的汇率
      cnyRate: 1, // 人民币汇率（缓存）
      usdRate: 1, // 美金汇率（缓存）
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'curDate'),
          align: 'left',
          dataIndex: 'curDate'
        },
        {
          title: '到期应还款',
          align: 'left',
          dataIndex: 'curAmount',
          customRender: this.convertAmount
        },
        {
          title: '实际还款金额',
          align: 'left',
          dataIndex: 'profitAmount',
          customRender: this.convertAmount
        },
        {
          title: '放款金额',
          align: 'left',
          dataIndex: 'paymentAmt',
          customRender: this.convertAmount
        },
        {
          title: '利润',
          align: 'left',
          dataIndex: 'profit',
          customRender: this.convertAmount
        },
        {
          title: '首逾',
          align: 'left',
          dataIndex: 'firstOverDueRate'
        },
        {
          title: '实时逾期率（含滞纳金）',
          align: 'left',
          dataIndex: 'overDueRate'
        },
        {
          title: '实时逾期率（不含滞纳金）',
          align: 'left',
          dataIndex: 'overDueNoLateFeeRate'
        },
        // {
        //   title: '实时逾期率（含部分还款）',
        //   align: 'left',
        //   dataIndex: 'overDuePartRate'
        // },
        {
          title: '利润率',
          align: 'left',
          dataIndex: 'profitRate'
        }
      ]
    }
  },
  created() {
    this.initAllRates()
    this.loadData(1)
    getApplist().then(res => {
      this.appList = []
      this.appInList = res.data || []
      for (var i = 0; i < this.appInList.length; i++) {
        if (this.appInList[i].appssid != '') {
          this.appList.push(this.appInList[i])
        }
      }
    })
    getApplistExcludingSubApp().then(res => {
      this.mainAppList = []
      this.mainInAppList = res.data || []
      for (var i = 0; i < this.mainInAppList.length; i++) {
        if (this.mainInAppList[i].appssid != '') {
          this.mainAppList.push(this.mainInAppList[i])
        }
      }
    })
  },
  methods: {
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    searchQuery(arg) {
      this.loadData(1, arg)
    },
    loadData(arg, arg2) {
      // 加载数据 若传入参数1则加载第一页的内容
      console.log(arg2)
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      var params = this.getQueryParams(arg2) // 查询条件
      this.exportParams = Object.entries(params).map(([key, value]) => key + '=' + value)
      getRepaymentReportForAmountReal(Object.assign({}, params))
        .then(res => {
          if (res.code === 1000) {
            // this.total = res.data && res.data.total
            this.dataSource = res.data || []

            for (var i = 0; i < this.dataSource.length; i++) {
              var dataIn = this.dataSource[i]
              dataIn.profit = (dataIn.profitAmount - dataIn.paymentAmt).toFixed(2)
            }
          } else {
            this.total = 0
            this.dataSource = []
            this.$message.error(res.msg)
          }
          this.loading = false
        })
        .catch(e => {
          this.loading = false
          this.$message.error(e.message)
        })
    },
    downLoadData() {
      const file = {
        fileUrl: '/api/web/statistics/platform/repaymentReportExcel?' + this.exportParams,
        fileName: 'report.xls'
      }
      this.loading = true
      exportFile(file)
        .catch(e => {
          this.$message.error(e.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    getQueryParams(arg) {
      const { examineDate } = this.queryParam
      const data = {
        ...this.queryParam,
        startDate: examineDate && this.transformTime(examineDate[0]),
        endDate: examineDate && this.transformTime(examineDate[1]),
        loanType: arg,
        appSsids: (this.queryParam.appSsids && this.queryParam.appSsids.length>0) ?this.queryParam.appSsids.join(",") : undefined
      }
      delete data.examineDate
      return filterObj(data)
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.examinerName = ''
      that.queryParam.examineDate = undefined
      that.queryParam.mainSids = []
      that.queryParam.appSsids = []
      that.loadData(this.form.pageNum)
    },

    // 初始化所有汇率（页面加载时执行）
    initAllRates () {
      const currency = process.env.VUE_APP_CURRENCY
      console.log('currency--->', currency)
      if(!currency)
        return

      getExchangeRate({currency: currency}).then((res)=>{
        if(res.code===1000){

          this.data = res.data || [];

          this.cnyRate = this.data['CNY'] || 1
          this.usdRate = this.data['USD'] || 1
        }else{
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      })
    },

    // 货币切换处理
    onCurrencyChange (e) {
      const selectedCurrency = e.target.value

      switch (selectedCurrency) {
        case 'LOCAL':
          this.exchangeRate = 1
          this.$message.info('已切换为本币')
          break
        case 'CNY':
          if (this.cnyRate !== null && this.cnyRate !== undefined) {
            this.exchangeRate = this.cnyRate
            this.$message.success(`已切换到人民币，汇率：${this.cnyRate}`)
          } else {
            this.$message.warning('人民币汇率未加载')
          }
          break
        case 'USD':
          if (this.usdRate !== null && this.usdRate !== undefined) {
            this.exchangeRate = this.usdRate
            this.$message.success(`已切换到人民币，汇率：${this.usdRate}`)
          } else {
            this.$message.warning('美金汇率未加载')
          }
          break
      }
    },

    // 汇率转换格式化方法（使用公共工具）
    convertAmount (text) {
      return this.$convertCurrency(text, this.exchangeRate)
    },
  }
}
</script>
<style lang="less" scoped>
@import '~@/assets/less/common.less';
</style>
